import { Helmet } from "react-helmet";
import { Heading, Img, Button, Text, Switch } from "../../components";
import AddPageProviderRow1 from "../../components/AddPageProviderRow1";
import AddPageProviderRow2 from "../../components/AddPageProviderRow2";
import TestFile3AfterColumn from "../../components/TestFile3AfterColumn";
import React, { Suspense, useState, useEffect } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
import LeftMenuOffersProvider from "components/LeftMenuOffersProvider";
import "styles/style.css";
import { API_DOMAIN_IMG, API_DOMAIN } from "config";
import axios from "axios";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/ImageCarousel";
import AddNewOfferTemplate from "components/AddNewOfferTemplate";
import SendNewOfferPopup from "components/SendNewOfferPopup";
import SendNewOfferMobilePopup from "components/SendNewOfferMobilePopup";
import LeftMenuNotificationsDealer from "components/LeftMenuNotificationsDealer";
import EditCar from "components/EditCar";
import LeftSendOffer from "components/LeftSendOffer";
const transactionDetailsList = [
  { blocktitle: "פרטי הרכב" },
  { blocktitle: "מפרט טכני" },
  { blocktitle: "מנוע וביצועים" },
  { blocktitle: "אבזור ונוחות" },
  // { blocktitle: "מידע על העיסקה" },
];

export default function CarFullProfile({ currentUser }) {
  const { id } = useParams();

  const [car, setCar] = useState([]);
  const [loadingCar, setLoadingCar] = useState(true);

  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [isDealer, setIsDealer] = useState(true);

  const [offer, setOffer] = useState(null);
  const [hasRejectedOrApproved, setHasRejectedOrApproved] = useState(false);
  const [loadingOffer, setLoadingOffer] = useState(true);

  const [accessoriesSelected, setAccessoriesSelected] = useState(car?.accessories || []);
  const [isEditCarPopupOpen, setIsEditCarPopupOpen] = useState(false);

  const [isAddNewOfferPopupOpen, setIsAddNewOfferPopupOpen] = useState(false);
  const [isAddNewOfferMobilePopupOpen, setIsAddNewOfferMobilePopupOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
const navigate = useNavigate();
const location = useLocation();

const handleBack = () => {
  const backUrl = location.state?.backUrl;

  if (backUrl) {
    navigate(backUrl, { replace: true });
  } else {
    navigate(-1); // אם אין backUrl, חוזר רגיל
  }
};

  const [checkboxes, setCheckboxes] = useState({
    למכירה: true,
    לפירוק: false,
    למכרז: false,
  });

  const toggleTab = (tabIndex) => {
    setActiveTab(activeTab === tabIndex ? null : tabIndex);
  };

  const updateIsAddNewOfferPopupOpen = (state) => {
    setIsAddNewOfferPopupOpen(state);
  };

  const updateIsAddNewOfferMobilePopupOpen = (state) => {
    setIsAddNewOfferMobilePopupOpen(state);
  };

  const isMobile = () => (typeof window !== "undefined" ? window.innerWidth < 768 : false);

  const openOfferPopup = () => {
    if (isMobile()) {
      updateIsAddNewOfferMobilePopupOpen(true);
    } else {
      updateIsAddNewOfferPopupOpen(true);
    }
  };

useEffect(() => {
  // תמיד לראש העמוד כשנכנסים לפרופיל רכב / כש-id משתנה
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}, [id]);

  useEffect(() => {
    console.log("currentUser", currentUser);
  }, []);

  useEffect(() => {
    const fetchOffer = async () => {
      if (!currentUser?.id || !id) return;
      try {
        const { data } = await axios.get(`${API_DOMAIN}/offer/getUserOffer`, {
          params: { car_id: id, user_id: currentUser.id },
        });

        const isRejectedOrApproved = data?.status === "2" || data?.status === "3";

        setOffer(data ?? null);
        setHasRejectedOrApproved(isRejectedOrApproved);

        // אם יש הצעה → לכבות "שיריון" (כמו שהיה אצלך)
        setIsSwitchOn(!data);
      } catch (e) {
        console.error("שגיאה בשליפת הצעה קיימת:", e);
      } finally {
        setLoadingOffer(false);
      }
    };

    fetchOffer();
  }, [currentUser?.id, id]);

  useEffect(() => {
    if (!id || !currentUser?.id) return;

    const getCarById = async () => {
      try {
        setLoadingCar(true);

        const { data } = await axios.get(`${API_DOMAIN}/car/getCarById/${id}`, {
          params: { user_id: currentUser.id },
        });

        const carData = {
          ...data,
          accessories:
            typeof data.accessories === "string"
              ? JSON.parse(data.accessories)
              : data.accessories || [],
        };

        setCar(carData);
        setAccessoriesSelected(carData.accessories);
      } catch (err) {
        console.error("שגיאה בשליפת רכב:", err);
      } finally {
        setLoadingCar(false);
      }
    };

    getCarById();
  }, [id, currentUser?.id]);

  const fetchCar = async () => {
    if (!id || !currentUser?.id) return;
    try {
      setLoadingCar(true);

      const { data } = await axios.get(`${API_DOMAIN}/car/getCarById/${id}`, {
        params: { user_id: currentUser.id },
      });

      const carData = {
        ...data,
        accessories:
          typeof data.accessories === "string"
            ? JSON.parse(data.accessories)
            : data.accessories || [],
      };

      setCar(carData);
      setAccessoriesSelected(carData.accessories);
    } catch (err) {
      console.error("שגיאה בשליפת רכב:", err);
    } finally {
      setLoadingCar(false);
    }
  };

  const providerLabel = (() => {
    if (currentUser?.user_type === 3) return "סוחר";
    if (currentUser?.provider_type === "private") return "מוכר פרטי";
    return "ספק";
  })();

  const buttonText = !offer
    ? "שלח הצעת מחיר"
    : offer.status === 3 || offer.status === 2
      ? "צפה בהצעת מחיר"
      : offer.status === 1
        ? "עדכן הצעת מחיר"
        : "שלח הצעת מחיר";

  const isArchiveStatus = ((car?.is_archive == 1) || car?.not_interested == 1) && !offer;

  const hideTopMenu =
    offer?.status == 2 || offer?.status == 3 || isArchiveStatus || currentUser?.user_type == 2;

  const DEFAULT_IMG = "/images/img_car11_qgcqjcnfp_428x738.png";

  const displayImages = React.useMemo(() => {
    if (loadingCar) return [];
    const has = Array.isArray(car?.images) && car.images.length > 0;
    return has ? car.images : [{ image_url: DEFAULT_IMG, __isDefault: true }];
  }, [car?.images, loadingCar]);

  const getSafeImage = (imagesArr) => {
    if (!Array.isArray(imagesArr) || imagesArr.length === 0) return null;
    return imagesArr[1] || imagesArr[0];
  };

  const mainImage = getSafeImage(displayImages);

  const imageRequestVersion = React.useMemo(
    () => Date.now(),
    [car?.updated_date, car?.images]
  );

  const buildImgSrc = (imgObj) => {
    if (!imgObj?.image_url) return DEFAULT_IMG;
    if (imgObj.__isDefault) return imgObj.image_url;
    const src = `${API_DOMAIN}/${imgObj.image_url}`;
    return `${src}${src.includes("?") ? "&" : "?"}v=${imageRequestVersion}`;
  };

  return (
    <>
      {/* ✅ עטיפת עמוד עם קלאס ייעודי למובייל בלבד */}
      <div className="car-full-profile-page">
        <div
          className="car-full-profile car-full-profile-shell flex bg-blue_gray-50 p-8 sm:p-4"
          style={{ width: "73%", marginLeft: "20.7%", paddingTop: "1rem" }}
        >
          <div className="container-9xl flex items-start gap-10 md:flex-col">
            <div className="relative pt-0 flex flex-1 flex-col items-start gap-[30px] self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4 car-full-profile-card">
              {/* פס עליון */}
                <div style={{width: '15%'}} className="ml-3 w-[9%] absolute top-0 left-0 h-8  flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                <div className="flex w-full justify-center gap-1">
                  <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                    <span className="text-gray-900_04">&nbsp;</span>
                    <span className="font-heebo font-medium text-gray-600">מודעת רכב</span> 
                  </Heading>
                  <Img src="/images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                </div>
                <div className="flex w-full items-center justify-center">
                  <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                   {providerLabel}
                  </Heading>
                  <Img src="/images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                </div>
              </div>
              <div className="flex flex-col gap-5 self-stretch px-11 md:px-5 sm:px-4 car-full-profile-body">
                <div className="mx-3.5 flex flex-col gap-[26px] md:mx-0 mt-4 car-full-profile-header">
                  {/* Breadcrumb */}
                  <div className="flex items-center justify-center car-full-profile-breadcrumb">
                    <div className="flex flex-1 justify-end">
                      <Text size="textlg" as="p" className="self-end text-[16px] font-normal !text-black-900_7f lg:text-[13px]">
                        {car?.model} {" "}{car?.manufacturer}
                      </Text>
                    </div>

                    <div className="flex w-[6%] items-center justify-center gap-1">
                      <Text as="p" className="!font-dmsans text-[14px] font-normal">&nbsp;/</Text>
                      <div className="flex flex-1 justify-center">
                        <Text size="h4_assistant16px_r" as="p" className="self-end text-[16px] font-normal !text-black-900_7f lg:text-[13px] w-18px">
                          {providerLabel}
                        </Text>
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-1 py-0.5">
                      <Text as="p" className="!font-dmsans text-[14px] font-normal">&nbsp;/</Text>
                      <Text size="textlg" as="p" className="self-end text-[16px] font-normal !text-black-900_7f lg:text-[13px]">
                        ראשי
                      </Text>
                    </div>
                  </div>

                  {/* כפתור עריכת רכב (ספק) */}
                  {currentUser?.user_type === 2 && (
                    <div className="mb-1.5 flex flex-1 items-center justify-center md:flex-col md:self-stretch car-full-profile-editrow">
                      <Button
                        size="lg"
                        shape="round"
                        leftIcon={
                          <div className="flex h-[10px] w-[6px] items-center justify-center">
                            <span className="text-lg leading-none">‹</span>
                          </div>
                        }
                        className="min-w-[128px] gap-2 rounded-[16px] px-3 font-semibold bg-black text-white"
                        style={{ background: "black", color: "white" }}
                        onClick={() => setIsEditCarPopupOpen(true)}
                      >
                        עריכת רכב
                      </Button>
                      <div className="flex flex-1 items-center justify-center px-2.5 md:self-stretch" />
                    </div>
                  )}

                  {/* שורה עליונה עם כפתור + switch + כותרת */}
                  {!hideTopMenu && (
                    <div className="hide-mobile flex items-center justify-center md:flex-col car-full-profile-actions">
                      <div className="mb-1.5 flex flex-1 items-center justify-center md:flex-col md:self-stretch car-full-profile-actions-left">
                        <Button
                          size="lg"
                          shape="round"
                          leftIcon={
                            <div className="flex h-[10px] w-[6px] items-center justify-center">
                              <span className="text-lg leading-none">‹</span>
                            </div>
                          }
                          className="min-w-[128px] gap-2 rounded-[16px] px-3 font-semibold bg-black text-white"
                          style={{ background: "black", color: "white" }}
                          onClick={() => { openOfferPopup(); }}
                        >
                          {buttonText}
                        </Button>

                        <div className="flex flex-1 items-center justify-center px-2.5 md:self-stretch car-full-profile-switchwrap">
                        {/*  <Switch
                            checked={isSwitchOn}
                            onCheckedChange={(val) => {
                              setIsSwitchOn(val);
                              if (!val) {
                                updateIsAddNewOfferPopup(true);
                              }
                            }}
                          />*/}
                        {/*  <div className="flex flex-1 self-end px-[26px] sm:px-4 car-full-profile-switchlabel">
                            <Text size="textxl" as="p" className="text-[16px] font-normal !text-black-900_03 lg:text-[13px]">
                              שיריון הרכב
                            </Text>
                          </div>*/}
                        </div>
                      </div>

                      <Heading
                        size="h1_assistant_45px_m"
                        as="h4"
                        className="text-[45px] font-semibold !text-black-900 lg:text-[38px] md:text-[29px] sm:text-[23px] car-full-profile-title"
                      >
                        {car?.model} {" "}{car?.manufacturer}
                      </Heading>
                    </div>
                  )}
                </div>

                {/* וידאו + תמונה + קרוסלה */}
                <div className="mx-3.5 flex items-center gap-5 md:mx-0 md:flex-col car-full-profile-media">
                  <div className="flex w-[32%] flex-col gap-5 md:w-full car-full-profile-media-left">
                    {car?.video_url ? (
                      <video controls className="h-[204px] w-full rounded-[16px] object-cover bg-black car-full-profile-video">
                        <source src={`${API_DOMAIN}/${car.video_url}`} type="video/mp4" />
                        הדפדפן שלך לא תומך בניגון וידאו.
                      </video>
                    ) : (
                      <div className="h-[204px] w-full rounded-[16px] bg-gray-300 flex items-center justify-center text-gray-500 text-sm car-full-profile-video-placeholder">
                        <img src="/images/viedio-icon.svg" alt="video placeholder" />
                      </div>
                    )}

                    {mainImage ? (
                      <Img
                        src={buildImgSrc(mainImage)}
                        alt="car image"
                        className="h-[204px] rounded-[16px] object-cover w-full car-full-profile-mainimg"
                      />
                    ) : (
                      <div className="h-[204px] w-full rounded-[16px] bg-gray-300 flex items-center justify-center text-gray-500 text-sm car-full-profile-mainimg-placeholder">
                        אין תמונה
                      </div>
                    )}
                  </div>

                  <div className="flex-1 car-full-profile-carousel">
                    <ImageCarousel images={displayImages} />
                  </div>
                </div>

                {/* טאבים */}
                <div className="ml-3.5 md:ml-0 car-full-profile-tabs" style={{ marginBottom: "33vh" }}>
                  <div className="flex flex-col gap-2.5 rounded-md bg-secondary-primary_white" />
                  <div className="flex flex-col dir-rtl car-full-profile-tabslist">
                    <Suspense fallback={<div>Loading feed...</div>}>
{transactionDetailsList.map((d, index) => (
  <AddPageProviderRow2
    {...d}
    key={"list" + index}
    toggleTab={toggleTab}
    index={index}
    activeTab={activeTab}
    car={car}
    currentUser={currentUser}   // ✅ הוספה
    accessoriesSelected={accessoriesSelected}
    setAccessoriesSelected={setAccessoriesSelected}
  />
))}

                    </Suspense>
                  </div>
                  {currentUser?.user_type == "3" &&
                    !loadingOffer &&
                    !isArchiveStatus &&
                    offer?.offer_status !== 5 && (
                      <LeftSendOffer
                        car={car}
                        offer={
                          offer
                            ? {
                                ...offer,
                                offer_id: offer.id,
                                offer_status: offer.offer_status || offer.status,
                                offered_price: offer.offered_price,
                                creation_date: offer.creation_date,
                                collection_date: offer.collection_date,
                                last_payment_date: offer.last_payment_date,
                              }
                            : null
                        }
                        currentUser={currentUser}
                        onUpdateOffer={(updatedOffer) => {
                          const newOffer = {
                            ...updatedOffer,
                            offer_id: updatedOffer.id,
                            offer_status: updatedOffer.offer_status || updatedOffer.status || 1,
                            offered_price: updatedOffer.offered_price,
                            creation_date: updatedOffer.creation_date,
                            collection_date: updatedOffer.collection_date,
                            last_payment_date: updatedOffer.last_payment_date,
                          };
                          setOffer(newOffer);
                        }}
                        onClose={() => {
                          setIsAddNewOfferPopupOpen(false);
                          if (!offer) {
                            setIsSwitchOn(true);
                          }
                        }}
                      />
                    )}

                  {currentUser?.user_type == "3" &&
                    !loadingOffer &&
                    !isArchiveStatus &&
                    offer?.offer_status !== 5 && (
                      <Button
                        size="lg"
                        shape="round"
                        leftIcon={
                          <div className="flex h-5 w-5 items-center justify-center shrink-0">
                            <span className="text-[22px] leading-none font-normal -mt-[1px]">‹</span>
                          </div>
                        }
                        className="hide-desktop fixed bottom-7 right-1/2 translate-x-1/2 z-50 w-[87vw] max-w-[420px] h-[40px] gap-2 rounded-[16px] bg-black text-white flex flex-row items-center justify-center font-semibold text-[16px] cursor-pointer whitespace-nowrap px-3"
                        style={{ background: "black", color: "white", borderRadius: "50px" }}
                        onClick={() => { openOfferPopup(); }}
                      >
                        {buttonText}
                        <img src="/images/offer-white.svg" alt="offer" className="h-4 w-4" />
                      </Button>
                    )}
                </div>
              </div>
            </div>
          </div>

          {isAddNewOfferPopupOpen && (
            <SendNewOfferPopup
              car={car}
              offer={
                offer
                  ? {
                      ...offer,
                      offer_id: offer.id,
                      offer_status: offer.offer_status || offer.status,
                      offered_price: offer.offered_price,
                      creation_date: offer.creation_date,
                      collection_date: offer.collection_date,
                      last_payment_date: offer.last_payment_date,
                    }
                  : null
              }
              currentUser={currentUser}
              onUpdateOffer={(updatedOffer) => {
                const newOffer = {
                  ...updatedOffer,
                  offer_id: updatedOffer.id,
                  offer_status: updatedOffer.offer_status || updatedOffer.status || 1,
                  offered_price: updatedOffer.offered_price,
                  creation_date: updatedOffer.creation_date,
                  collection_date: updatedOffer.collection_date,
                  last_payment_date: updatedOffer.last_payment_date,
                };

                setOffer(newOffer);
              }}
              onClose={() => {
                setIsAddNewOfferPopupOpen(false);

                if (!offer) {
                  setIsSwitchOn(true);
                }
              }}
            />
          )}

          {isAddNewOfferMobilePopupOpen && (
            <SendNewOfferMobilePopup
              car={car}
              offer={
                offer
                  ? {
                      ...offer,
                      offer_id: offer.id,
                      offer_status: offer.offer_status || offer.status,
                      offered_price: offer.offered_price,
                      creation_date: offer.creation_date,
                      collection_date: offer.collection_date,
                      last_payment_date: offer.last_payment_date,
                    }
                  : null
              }
              currentUser={currentUser}
              onUpdateOffer={(updatedOffer) => {
                const newOffer = {
                  ...updatedOffer,
                  offer_id: updatedOffer.id,
                  offer_status: updatedOffer.offer_status || updatedOffer.status || 1,
                  offered_price: updatedOffer.offered_price,
                  creation_date: updatedOffer.creation_date,
                  collection_date: updatedOffer.collection_date,
                  last_payment_date: updatedOffer.last_payment_date,
                };

                setOffer(newOffer);
              }}
              onClose={() => {
                setIsAddNewOfferMobilePopupOpen(false);

                if (!offer) {
                  setIsSwitchOn(true);
                }
              }}
            />
          )}
        </div>

        {isEditCarPopupOpen && (
          <EditCar
            car={car}
            currentUser={currentUser}
            onClose={() => setIsEditCarPopupOpen(false)}
            onCarUpdated={() => {
              setIsEditCarPopupOpen(false);
              fetchCar();
            }}
          />
        )}
      </div>
    </>
  );
}
